import React from 'react'
import PlayerSubScreen from '../components/PlayerSubScreen'

const PlayerMainScreen = () => {
  return (
    <>
    
    <PlayerSubScreen/>
    </>
  )
}

export default PlayerMainScreen